// app.routing.js

"use strict";

import { home, areaCliente, areaClienteInicioSesion, areaClienteCambiarPass, areaClienteGenerarPass } from "./app.states";

appRouting.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$urlMatcherFactoryProvider"];

function appRouting($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {
  $urlMatcherFactoryProvider.strictMode(false);
  $urlRouterProvider.otherwise("/");
  $locationProvider.html5Mode(true);
  $stateProvider.state(home);
  $stateProvider.state(areaCliente);
  $stateProvider.state(areaClienteInicioSesion);
  $stateProvider.state(areaClienteCambiarPass);
  $stateProvider.state(areaClienteGenerarPass);  
}

export { appRouting };
